import { queries } from "lib/build/dashboards/ktx/queries";
import { mapInterpretationToString, Origin } from "lib/build/events";

import {
	getEllapsedTimeInMonths,
	getNumberOfDays
} from "src/common/utils/dates";
import { useLastEventByQuery } from "src/features/events";
import { useOrgModParams } from "src/features/orgmod";
import { sidToForms } from "src/sidToForms";

export function useWaitingListTime(): {
	value: number | undefined;
	timestamp?: string;
	origin?: Origin;
	days?: boolean;
} {
	const { mod } = useOrgModParams();

	const q = queries.waitingListStartDate;
	if (q.interpretation === undefined) {
		throw new Error();
	}

	const event = useLastEventByQuery<Date>(q);
	if (event === undefined) {
		return { value: undefined };
	}

	const sid = mapInterpretationToString(q.interpretation);
	const noForm =
		!(sid in sidToForms[mod]) || sidToForms[mod][sid].length === 0;

	const start = new Date(event.value);
	const now = new Date();

	const elapsedTimeInMonths = getEllapsedTimeInMonths(start, now);
	let v = Math.round(elapsedTimeInMonths);
	let days = false;

	if (elapsedTimeInMonths < 1) {
		v = getNumberOfDays(event.value, now);
		days = true;
	}

	return {
		value: v,
		timestamp: event.timestamp,
		origin: noForm ? undefined : event.origin,
		days
	};
}
